import React, { useState, useEffect} from "react";
import { Dropdown } from "primereact/dropdown";
import DashboardAnalyticsDocs from "../components/DashboardAnalyticsDocs";
import DashboardAnalyticsClient from "../components/DashboardAnalyticsClient";
import { useGlobalContext } from "../Config";
import { ProgressSpinner } from 'primereact/progressspinner';


const Dashboards = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { baseUrl } = useGlobalContext();
  const [empresas, setEmpresas] = useState([]);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  //-------------------------
  //OBTENER PERIODOS
  //-------------------------
  const getRangeMonths = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth(); // getMonth() es base 0
    const months = [];
    for (let m = 1; m <= currentMonth; m++) {
      const monthString = currentYear + '-' + m.toString().padStart(2, '0');
      months.push(monthString);
    }
    return months;
  };

  //-------------------------
  // SELECTOR DE EMPRESAS
  //-------------------------
  const obtenerEmpresas = async () => {
    try {
      const response = await fetch(`${baseUrl}/getAllEmpresas`);
      const data = await response.json();
      const empresasConTodas = [{ nombre: "Todas" }, ...data.empresas];
      setEmpresas(empresasConTodas);
      const altamira = data.empresas.find(e => e.nombre === "ALTAMIRA");
      if (altamira) {
        setEmpresaSeleccionada(altamira.nombre); // usar el ID como valor inicial
      }
    } catch (error) {
      console.error("Error al obtener las empresas:", error);
    }
  };

  //-------------------------
  //OBTENER DATA
  //-------------------------
  const fetchPeriodoFacturacion = async (empresasSeleccionadas) => {
    const meses = getRangeMonths();
    const url = `${baseUrl}getPeriodoFacturacionByAnalytics`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        periodos: meses,
        empresas: empresasSeleccionadas
      })
    });
  
    const result = await response.json();
    if (!result || !Array.isArray(result.data)) {
      setLoading(false);
      return;
    }
    const allData = [];
  
    for (const periodo of result.data) {
      //-------------------------
      // usar data del periodo anterior
      //-------------------------
      const [year, month] = periodo.periodo.split("-").map(Number);
      const adjustedDate = new Date(year, month - 1); // base 0
            adjustedDate.setMonth(adjustedDate.getMonth() + 1); // desfase hacia adelante
            const mes = `${adjustedDate.getFullYear()}-${(adjustedDate.getMonth() + 1)
              .toString()
              .padStart(2, "0")}`;
      const documentoArray = periodo.asignacionesPeriodo.map(item => item.detalles_total || {});
      const totalPfUfFinal = periodo.totalPfUfFinal;
      //-------------------------
      // histograma de totales documentos por mes
      //-------------------------
      const totalDocumentos = documentoArray.reduce(
        (acc, doc) => {
          acc.f_afecta += doc.f_afecta || 0;
          acc.f_exenta += doc.f_exenta || 0;
          acc.n_cobro += doc.n_cobro || 0;
          return acc;
        },
        { f_afecta: 0, f_exenta: 0, n_cobro: 0 }
      );


      allData.push({ 
        mes, 
        totalPfUfFinal,
        documento_total: totalDocumentos, 
        asignacionesPeriodo: periodo.asignacionesPeriodo
      });
    }
    
    console.log("DATA FINAL FORMATEADA:", allData);
    setData(allData);
    setLoading(false);
  };

  //-------------------------
  //EFECTO SECUNDARIO
  //-------------------------
  useEffect(() => {
    obtenerEmpresas();
  }, []);

  useEffect(() => {
    if ( empresaSeleccionada) {
      if (empresaSeleccionada === "Todas") {
        const nombresEmpresas = empresas.filter(e => e.nombre !== "Todas").map(e => e.nombre);
        fetchPeriodoFacturacion(nombresEmpresas);
      } else {
        fetchPeriodoFacturacion([empresaSeleccionada]);
      }
    }
  }, [empresaSeleccionada]);

  //-------------------------
  // DESPLIEGUE DASHBOARD CABECERA
  //-------------------------
  return ( 
    <div className="grid">
      <div className="col-12">
        <div className="card">
          <h4 style={{ marginBottom: "5px" }}>Resumen de Ingresos</h4>
          <h6 style={{ marginTop: "5px" }}>
            Muestra el resumen de ingresos para la empresa seleccionada.
          </h6>
          <div className="p-field">
            <label htmlFor="empresa">Seleccione Empresa: </label>
            <Dropdown
              id="empresa"
              value={empresaSeleccionada}
              options={empresas}
              optionLabel="nombre"
              optionValue="nombre"
              onChange={(e) => {
                setLoading(true);
                setEmpresaSeleccionada(e.value);
              }}
              placeholder="Seleccione Empresa"
              disabled={loading}
            />
          </div>
        </div>      
      </div>
      <div className="col-12">
        {loading ? (
          <div className="flex justify-content-center align-items-center" style={{ height: '300px' }}>
            <ProgressSpinner />
          </div>
        ) : (
          <>
            <DashboardAnalyticsClient data={data} />
            <DashboardAnalyticsDocs data={data} />
          </>
        )}
      </div>
    </div>
  );
};
export default Dashboards;

